module.exports = __webpack_public_path__ + "od-checked-sharp-circle-icon/od-checked-sharp-circle-icon-2086348b9bd57138915fdf8a6efaae07.svg";